/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { settingAdminControllerGetBusinessInfoV1 } from '../fn/setting-admin/setting-admin-controller-get-business-info-v-1';
import { SettingAdminControllerGetBusinessInfoV1$Params } from '../fn/setting-admin/setting-admin-controller-get-business-info-v-1';
import { settingAdminControllerGetSettingsV1 } from '../fn/setting-admin/setting-admin-controller-get-settings-v-1';
import { SettingAdminControllerGetSettingsV1$Params } from '../fn/setting-admin/setting-admin-controller-get-settings-v-1';
import { settingAdminControllerSetBusinessInfoV1 } from '../fn/setting-admin/setting-admin-controller-set-business-info-v-1';
import { SettingAdminControllerSetBusinessInfoV1$Params } from '../fn/setting-admin/setting-admin-controller-set-business-info-v-1';
import { settingAdminControllerSetSettingsV1 } from '../fn/setting-admin/setting-admin-controller-set-settings-v-1';
import { SettingAdminControllerSetSettingsV1$Params } from '../fn/setting-admin/setting-admin-controller-set-settings-v-1';
import { SettingDto } from '../models/setting-dto';

@Injectable({ providedIn: 'root' })
export class SettingAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `settingAdminControllerGetSettingsV1()` */
  static readonly SettingAdminControllerGetSettingsV1Path = '/api/v1/settings/admin';

  /**
   * 모든 설정값 조회 (관리자).
   *
   * 모든 설정값을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `settingAdminControllerGetSettingsV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  settingAdminControllerGetSettingsV1$Response(params?: SettingAdminControllerGetSettingsV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SettingDto>>> {
    const obs = settingAdminControllerGetSettingsV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 모든 설정값 조회 (관리자).
   *
   * 모든 설정값을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `settingAdminControllerGetSettingsV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  settingAdminControllerGetSettingsV1(params?: SettingAdminControllerGetSettingsV1$Params, context?: HttpContext): Observable<Array<SettingDto>> {
    const resp = this.settingAdminControllerGetSettingsV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<SettingDto>>): Array<SettingDto> => r.body)
    );
  }

  /** Path part for operation `settingAdminControllerSetSettingsV1()` */
  static readonly SettingAdminControllerSetSettingsV1Path = '/api/v1/settings/admin';

  /**
   * 설정값 변경 (관리자).
   *
   * 설정값을 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `settingAdminControllerSetSettingsV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  settingAdminControllerSetSettingsV1$Response(params: SettingAdminControllerSetSettingsV1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = settingAdminControllerSetSettingsV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 설정값 변경 (관리자).
   *
   * 설정값을 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `settingAdminControllerSetSettingsV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  settingAdminControllerSetSettingsV1(params: SettingAdminControllerSetSettingsV1$Params, context?: HttpContext): Observable<void> {
    const resp = this.settingAdminControllerSetSettingsV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `settingAdminControllerGetBusinessInfoV1()` */
  static readonly SettingAdminControllerGetBusinessInfoV1Path = '/api/v1/settings/admin/business-info';

  /**
   * 사업자 정보 조회.
   *
   * 사업자 정보를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `settingAdminControllerGetBusinessInfoV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  settingAdminControllerGetBusinessInfoV1$Response(params?: SettingAdminControllerGetBusinessInfoV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
[key: string]: string;
}>> {
    const obs = settingAdminControllerGetBusinessInfoV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 사업자 정보 조회.
   *
   * 사업자 정보를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `settingAdminControllerGetBusinessInfoV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  settingAdminControllerGetBusinessInfoV1(params?: SettingAdminControllerGetBusinessInfoV1$Params, context?: HttpContext): Observable<{
[key: string]: string;
}> {
    const resp = this.settingAdminControllerGetBusinessInfoV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
[key: string]: string;
}>): {
[key: string]: string;
} => r.body)
    );
  }

  /** Path part for operation `settingAdminControllerSetBusinessInfoV1()` */
  static readonly SettingAdminControllerSetBusinessInfoV1Path = '/api/v1/settings/admin/business-info';

  /**
   * 사업자 정보 저장.
   *
   * 사업자 정보를 저장합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `settingAdminControllerSetBusinessInfoV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  settingAdminControllerSetBusinessInfoV1$Response(params: SettingAdminControllerSetBusinessInfoV1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = settingAdminControllerSetBusinessInfoV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 사업자 정보 저장.
   *
   * 사업자 정보를 저장합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `settingAdminControllerSetBusinessInfoV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  settingAdminControllerSetBusinessInfoV1(params: SettingAdminControllerSetBusinessInfoV1$Params, context?: HttpContext): Observable<void> {
    const resp = this.settingAdminControllerSetBusinessInfoV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
